import { render, staticRenderFns } from "./loginindex.vue?vue&type=template&id=78f0f52c&scoped=true&"
import script from "./loginindex.vue?vue&type=script&lang=js&"
export * from "./loginindex.vue?vue&type=script&lang=js&"
import style0 from "./loginindex.vue?vue&type=style&index=0&id=78f0f52c&scoped=true&lang=css&"
import style1 from "./loginindex.vue?vue&type=style&index=1&id=78f0f52c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0f52c",
  null
  
)

export default component.exports